import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import {
  PaymentSchedulerGuestCheckoutService,
  PaymentSchedulerPaymentLinksService,
  PaymentSchedulerPlatformService,
  PaymentSchedulerService,
} from '../services';
import { Injectable } from '@angular/core';

export const paymentSchedulerServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
) => {
  let service: PaymentSchedulerService;

  if (appConfig.getconfig('usePaymentLinkEndpoints') === 'true') {
    service = new PaymentSchedulerPaymentLinksService(httpClient, appConfig);
  } else if (appConfig.getconfig('useHostedPaymentsPageEndpoints') === 'true') {
    service = new PaymentSchedulerGuestCheckoutService(httpClient, appConfig);
  } else {
    service = new PaymentSchedulerPlatformService(httpClient, appConfig);
  }

  return service;
};

@Injectable({
  providedIn: 'root',
})
export class PaymentSchedulerServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create() {
    return paymentSchedulerServiceFactory(this.httpClient, this.appConfig);
  }
}
